// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"5eecf4f0","319":"3251a849","453":"f8e7cfbd","739":"e5876496","863":"48c55839"}[chunkId] + ".chunk.css";
};